import { Button, Result } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage: FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button
            type="primary"
            onClick={() => {
              navigate("/dashboard");
            }}
          >
            กลับหน้าหลัก
          </Button>
        }
      />
    </>
  );
};

export default NotFoundPage;
